import { type AccountInfo, PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

const isSingleSpa = process.env.SINGLE_SPA === "true";
const CLIENT_ID: string = isSingleSpa ? process.env.CACTUS_CLIENT_ID || "" : process.env.CLIENT_ID || "";

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const authenticationParams = {
  scopes: [`${CLIENT_ID}/.default`],
};

export const msalInstance = new PublicClientApplication(msalConfig);
export const getAccessToken = async (): Promise<string | null> => {
  await msalInstance.initialize();
  const accounts = msalInstance.getAllAccounts();

  if (accounts.length > 0) {
    try {
      const request = {
        ...authenticationParams,
        account: accounts[0],
        forceRefresh: false, // Set to true to force refresh
      };

      const response = await msalInstance.acquireTokenSilent(request);
      return response.accessToken;
    } catch (error) {
      console.error("Silent token acquisition failed:", error);

      // If silent token acquisition fails, we might need to refresh
      // but we shouldn't do interactive auth here since it should be handled by the provider
      try {
        // Try one more time with forceRefresh
        const refreshRequest = {
          ...authenticationParams,
          account: accounts[0],
          forceRefresh: true,
        };

        const refreshResponse = await msalInstance.acquireTokenSilent(refreshRequest);
        return refreshResponse.accessToken;
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        return null;
      }
    }
  }

  return null;
};

// Account selection logic is app dependent. Adjust as needed for different use cases.
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    // @ts-expect-error: see above
    const account: AccountInfo = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});
